import { INIT_EDIT_QUOTE } from 'store/quotes/types';

import { types } from './actions';

const initialState = {
  isMakeAssemblyModalOpen: false,
  shouldAskAboutMakeSupportingFile: false,
  shouldAskAboutOps: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case INIT_EDIT_QUOTE:
      return { ...initialState };
    case types.MAKE_ASSEMBLY_MODAL_OPEN:
      return {
        ...state,
        isMakeAssemblyModalOpen: true,
        shouldAskAboutMakeSupportingFile:
          action.payload.shouldAskAboutMakeSupportingFile,
        shouldAskAboutOps: action.payload.shouldAskAboutOps,
      };
    case types.MAKE_ASSEMBLY_MODAL_CLOSE:
    case types.MAKE_ASSEMBLY_MODAL_CONFIRM:
      return {
        ...state,
        isMakeAssemblyModalOpen: false,
      };
    default:
      return state;
  }
};

export default reducer;

const getScope = (state) => state.modules.quotes.makeAssemblyModal;

export const getIsMakeAssemblyModalOpen = (state) =>
  getScope(state).isMakeAssemblyModalOpen;

export const getShouldAskAboutMakeSupportingFile = (state) =>
  getScope(state).shouldAskAboutMakeSupportingFile;

export const getShouldAskAboutOps = (state) =>
  getScope(state).shouldAskAboutOps;
